import { useNavigate } from "react-router-dom";

import { useGuestPassHistory } from "@/hooks/useGuestPassHistory";

import Header from "../Header";
import Icon from "../Icon";
import Loader from "../Loader";
import HistoricalGuestPassCard from "./HistoricalGuestPassCard";

export type HistoricalGuestPass = {
  description: string;
  shareDate: string;
  shareMethod: string;
  receiverFirstName?: string;
  receiverLastName?: string;
  isClaimed: boolean;
  createdAt: number;
};

export const GuestPassHistory = () => {
  const { guestPasses } = useGuestPassHistory();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div
      className={
        "m-auto flex min-h-screen w-full max-w-lg flex-col justify-between px-6 pt-4 sm:p-10"
      }
    >
      <div className={"flex flex-col"}>
        <div className={"mb-8 flex flex-row justify-between"}>
          <Header className="h-8 w-80 justify-start font-['Poppins'] text-2xl font-semibold leading-loose text-sky-800">
            Guest Pass History
          </Header>
          <Icon name="close" onClick={goBack} />
        </div>
        {guestPasses.isPending && <Loader />}
        {!guestPasses.isPending && (
          <div className="mb-6 flex flex-col">
            {guestPasses.data?.history?.map((p: HistoricalGuestPass) => (
              <HistoricalGuestPassCard
                key={p.createdAt}
                historicalGuestPass={p}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
